import {useUserState} from '#hook';

import {RequireUserStateProps} from './RequireUserState.types';

export const RequireUserState = ({
  children,
  path,
  redirect,
  userState = 'verified',
}: RequireUserStateProps) => {
  const meetsRequirement = useUserState({state: userState, redirect, path});

  return meetsRequirement ? <>{children}</> : null;
};

export const withRequireUserState =
  (Component: React.ComponentType, userStateProps: RequireUserStateProps) =>
  (componentProps?: Record<any, unknown>) =>
    (
      <RequireUserState {...userStateProps}>
        <Component {...(componentProps || {})} />
      </RequireUserState>
    );
